import { restaurantPropTypes } from '@nandosaus/prop-types';
import React from 'react';

import { Button } from '../button';
import { Flex } from '../grid';
import { navigation } from '../../constants';
import { P } from '../typography';
import { StyledContainer } from '../content-image/styles';

const RestaurantOrderButton = ({ restaurant }) => {
  const { isOpen, id, orderingEnabled } = restaurant;

  const isRestaurantOpenAndTakeOrders = !!(orderingEnabled && isOpen);

  return (
    <StyledContainer my="1rem">
      <Flex flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" justifyContent="center" py="1rem">
        <P mb={{ xs: '1.5rem', md: 0 }} mr={{ xs: 0, md: '1rem' }} fontWeight="bold">
          Are you Hungry for Nando’s?
        </P>
        <Button
          disabled={!isRestaurantOpenAndTakeOrders}
          variant="primary"
          {...(isRestaurantOpenAndTakeOrders && {
            href: {
              pathname: navigation.MENU,
              query: { r: id, showAllOrderTypes: true },
            },
          })}
        >
          Order Now
        </Button>
      </Flex>
    </StyledContainer>
  );
};

RestaurantOrderButton.propTypes = {
  restaurant: restaurantPropTypes.isRequired,
};
export { RestaurantOrderButton };
